import type { ReactNode } from 'react'
import * as React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Sheet from 'components/utils/Sheet'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import CartPanelItemDispatcher from './CartPanelItemDispatcher'
import type { CartPanelExperienceItem, CartPanelFlightItem, CartPanelItem } from '../hooks/useCartPanelItems'

const ItemList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
`

interface Props {
  title: string
  icon: ReactNode
  items: Array<CartPanelItem>
  onToggleInclude: (item: CartPanelItem) => void
  onChangeRoom: (item: CartPanelItem) => void
  onSetDates: () => void
  onAdjustDays: (item: CartPanelItem) => void
  onChooseTickets: (item: CartPanelExperienceItem) => void
  onChooseDate: (item: CartPanelExperienceItem) => void
  onChooseTime: (item: CartPanelExperienceItem) => void
  onChooseDifferentTickets: (item: CartPanelExperienceItem) => void
  onChooseFlight: (item: CartPanelFlightItem) => void
  onRefreshFlight: (item: CartPanelFlightItem) => void
  onChangeFlight: (item: CartPanelFlightItem) => void
  onViewFlightDetails: (item: CartPanelFlightItem) => void
  refreshingFlightKey: string | undefined
  onDelete: (item: CartPanelItem) => void
  isStreaming: boolean
}

function CartPanelSection({
  title,
  icon,
  items,
  onToggleInclude,
  onChangeRoom,
  onSetDates,
  onAdjustDays,
  onChooseTickets,
  onChooseDate,
  onChooseTime,
  onChooseDifferentTickets,
  onChooseFlight,
  onRefreshFlight,
  onChangeFlight,
  onViewFlightDetails,
  refreshingFlightKey,
  onDelete,
  isStreaming,
}: Props) {
  return (
    <div>
      <Sheet padding="0 0 12">
        <HeadingTextBlock startIcon={icon} variant="heading5">{title}</HeadingTextBlock>
      </Sheet>
      <ItemList>
        {items.map((item) => (
          <CartPanelItemDispatcher
            key={item.key}
            item={item}
            onToggleInclude={onToggleInclude}
            onChangeRoom={onChangeRoom}
            onSetDates={onSetDates}
            onAdjustDays={onAdjustDays}
            onChooseTickets={onChooseTickets}
            onChooseDate={onChooseDate}
            onChooseTime={onChooseTime}
            onChooseDifferentTickets={onChooseDifferentTickets}
            onChooseFlight={onChooseFlight}
            onRefreshFlight={onRefreshFlight}
            onChangeFlight={onChangeFlight}
            onViewFlightDetails={onViewFlightDetails}
            refreshingFlightKey={refreshingFlightKey}
            onDelete={onDelete}
            isStreaming={isStreaming}
          />
        ))}
      </ItemList>
    </div>
  )
}

export default CartPanelSection
